/**
 * @generated SignedSource<<3de05495d6393a05a013bb86a5e3f407>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNodeSecurity_node$data = {
  readonly canUpdateSecurity?: {
    readonly value: boolean;
  };
  readonly draftVaultItemContent?: {
    readonly mimeType?: string;
  } | null;
  readonly folderItemContent?: {
    readonly mimeType?: string;
  };
  readonly hasWatermark?: boolean;
  readonly id: string;
  readonly preventDownload?: boolean;
  readonly vaultItemContent?: {
    readonly mimeType?: string;
  };
  readonly " $fragmentType": "useNodeSecurity_node";
};
export type useNodeSecurity_node$key = {
  readonly " $data"?: useNodeSecurity_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNodeSecurity_node">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      }
    ],
    "type": "File",
    "abstractKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNodeSecurity_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdateSecurity",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preventDownload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasWatermark",
          "storageKey": null
        }
      ],
      "type": "HasNodeSecurityInterface",
      "abstractKey": "__isHasNodeSecurityInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "folderItemContent",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "vaultItemContent",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "VaultItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "draftVaultItemContent",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "VaultDraftItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "f1525e5d0590f5ad7373c0e6524965e3";

export default node;
